import { render, staticRenderFns } from "./BtnGuardarCancelar.vue?vue&type=template&id=223e4121&"
import script from "./BtnGuardarCancelar.vue?vue&type=script&lang=js&"
export * from "./BtnGuardarCancelar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports